import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Attendance, Fixture } from "src/app/interfaces/Index";
import { FixtureService } from "src/app/services/Index";
import "./ScoreboardAdditionalTime.css";

type Props = {};
type State = {
	fixture: Fixture
	additionalMinutes: number
};
export class ScoreboardAdditionalTime extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {fixture: new Fixture, additionalMinutes: 0};
	}

	componentDidMount() {
		this.getLatest();		
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper" style={{textAlign: "center", width:576, height:432}}>
				<h1>ADDITIONAL TIME</h1>
				<h3> A minimum of...</h3>
				<h1 className="attendance-amount">+{this.state.additionalMinutes}</h1>
				<Row style={{width:576,height:100, backgroundColor:"#293246",position:"absolute",left:12, bottom:0}}>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/JS_AGroup_Shorter.jpg"} height="100"/></Col>
					</Row>	
			</div>
		);
	}

	async getLatest(){
		const res = await safeJson(FixtureService.getLatest());
		if (res && res.error) {
		}
		// No fixture, nothing to count added time against.
		if (!res) return;
		this.setState({fixture: res});

		var diff = Math.abs(new Date(res.fixtureDateTime).getTime() - new Date().getTime());
		var minutes = Math.floor((diff/1000)/60);
		if(minutes > 60) this.setState({additionalMinutes: res.secondHalfAdditional})
		else this.setState({additionalMinutes: res.firstHalfAdditional})

	}

	isSecondHalf(){
		console.log(this.state.fixture.fixtureDateTime);
		console.log(new Date(this.state.fixture.fixtureDateTime).getTime())
		console.log(new Date().getTime())
		
		var diff = Math.abs(new Date(this.state.fixture.fixtureDateTime).getTime() - new Date().getTime());
		var minutes = Math.floor((diff/1000)/60);
		console.log(minutes);
	}
}